import styled from 'styled-components'

const TitleTextCompStyle = styled.div.attrs({})`
    max-width: var(--sp108x);
    width: 100%;
    margin-left:auto;
    margin-right:auto;
    text-align:center;

    .subtitle {
        max-width: 84%;
        margin-left:auto;
        margin-right:auto;
    }

    button {
        margin-top: var(--sp8x);
    }

    @media only screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}){
        max-width: unset;

        .subtitle {
            max-width: 84%;
        }

        button {
            margin-top: var(--sp5x);
        }
    }
`
export default TitleTextCompStyle
